import React from 'react';

import {DeviceViewModel} from "../../../models/device.view-model";
import {ScoresHeaderSubHeaderPlaceholder} from "./scores-header.sub-header.placeholder";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {WithDevice} from "../../composers/with-device";

export class ScoresListWidgetDesktopHeaderPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresListWidgetDesktopHeaderPlaceholder = WithDevice((props: ScoresListWidgetDesktopHeaderPlaceholderProps) => {
  return (
    <div className={'scores-header-placeholder-container'}>
      <ScoresHeaderSubHeaderPlaceholder {...props}/>
    </div>
  )
});
